<template>
  <head>
    <meta charset="utf-8"/>
    <title>Desk Birdy | Business Permits</title>
    <meta content="width=device-width, initial-scale=1.0" name="viewport">
    <meta content="Rental management system by Nouveta LTD" name="description"/>
    <meta content="Kelvin Njuguna" name="author"/>
    <link href="assets/images/favicon.svg" rel="shortcut icon">
    <link href="assets/libs/dropzone/min/dropzone.min.css" rel="stylesheet" type="text/css"/>
    <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css"/>
    <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css"/>
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css"/>
    <link href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css" rel="stylesheet">
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css"/>
    <link href="./assets/libs/owl.carousel/assets/owl.carousel.min.css" rel="stylesheet">
    <link href="./assets/libs/owl.carousel/assets/owl.theme.default.min.css" rel="stylesheet">
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css"/>
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css"/>
  </head>

  <body @contextmenu.prevent data-sidebar="dark">
  <div id="layout-wrapper">
    <NavigationBar/>
    <div id="content" class="content-minimize">
      <div class="page-content">
        <div class="container-fluid">
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">Business Permits - Applications Pending Inspection</h4>
                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="index.html">Dashboards</a></li>
                    <li class="breadcrumb-item"><a href="#">Certificates & Licenses</a></li>
                    <li class="breadcrumb-item"><a href="cert-biz-stats.html">Business Permits</a></li>
                    <li class="breadcrumb-item active">Applications Pending Inspection</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-lg-3 col-md-6">
              <div class="card mini-stats-wid border-0 shadow-sm hover-card">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium mb-2">Total Applications</p>
                      <h4 class="mb-0 counter">{{ totalItems || 0 }}</h4>
                    </div>
                    <div class="mini-stat-icon avatar-sm align-self-center rounded-circle bg-primary bg-gradient">
                      <span class="avatar-title">
                        <i class="bx bx-copy-alt font-size-24"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-3 col-md-6">
              <div class="card mini-stats-wid border-0 shadow-sm hover-card">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium mb-2">Total Revenue</p>
                      <h4 class="mb-0 counter">KES {{ numberFormat(totalAmount) }}</h4>
                    </div>
                    <div class="mini-stat-icon avatar-sm align-self-center rounded-circle bg-success bg-gradient">
                      <span class="avatar-title">
                        <i class="bx bx-dollar font-size-24"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-3 col-md-6">
              <div class="card mini-stats-wid border-0 shadow-sm hover-card">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium mb-2">Pending Review</p>
                      <h4 class="mb-0 counter">{{ pendingCount }}</h4>
                    </div>
                    <div class="mini-stat-icon avatar-sm align-self-center rounded-circle bg-warning bg-gradient">
                      <span class="avatar-title">
                        <i class="bx bx-time font-size-24"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-3 col-md-6">
              <div class="card mini-stats-wid border-0 shadow-sm hover-card">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium mb-2">Today's Applications</p>
                      <h4 class="mb-0 counter">{{ todayCount }}</h4>
                    </div>
                    <div class="mini-stat-icon avatar-sm align-self-center rounded-circle bg-info bg-gradient">
                      <span class="avatar-title">
                        <i class="bx bx-calendar font-size-24"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <ToolBar/>

          <div class="row">
            <div class="col-12">
              <div class="card shadow-sm">
                <div class="card-header bg-white pt-0 pr-0 p-0 d-flex justify-content-between align-items-center w-100 border-bottom">
                  <div class="d-flex align-items-center justify-content-center p-3" role="toolbar">
                    <label class="text-nowrap mb-0 px-2">Date From:</label>
                    <input v-model="dateFrom" class="form-control pr-3" type="date">
                    <label class="text-nowrap mb-0 px-2">Date To:</label>
                    <input v-model="dateTo" class="form-control pr-2" type="date">
                    <select @change="selectedSubCounty($event)" class="form-control bg-white mx-2" data-live-search="true" title="Select Sub County">
                      <option value="">All Sub Counties</option>
                      <option :key="index" :value="JSON.stringify(item)" v-for="(item, index) in subCounties">
                        {{ item.subCountyName }}
                      </option>
                    </select>
                    <select @change="selectedWard($event)" class="form-control bg-white" data-live-search="true" title="Select Ward">
                      <option value="">All Wards</option>
                      <option :key="index" :value="JSON.stringify(item)" v-for="(item, index) in wards">
                        {{ item.wardName }}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="card-header bg-white pt-0 pr-0 p-0 d-flex justify-content-between align-items-center w-100 border-bottom">
                  <div class="d-flex align-items-center justify-content-center p-3 flex-grow-1" role="toolbar">
                    <form class="app-search p-0 m-0 w-100">
                      <div class="position-relative">
                        <input v-model="search" type="text" class="form-control w-100" placeholder="Search... eg Business Name, ID Number, Bill Number, etc">
                        <span class="bx bx-search-alt"></span>
                      </div>
                    </form>
                  </div>
                  <div class="pr-3">
                    <button v-if="getRight('SBP DOWNLOAD PENDING INSPECTION')" @click="downloadApplicationsPaginated()" class="btn btn-primary btn-rounded shadow-sm" :disabled="isDownloading">
                      <i class="bx bx-download me-2"></i>
                      {{ isDownloading ? 'Downloading...' : 'Download' }}
                    </button>
                  </div>
                </div>

                <div class="card-body">
                  <div class="table-responsive">
                    <table class="table align-middle table-hover contacts-table table-striped" id="datatable-buttons">
                      <thead class="table-light">
                      <tr class="table-dark">
                        <th scope="col">Receipt No.</th>
                        <th scope="col">Business ID</th>
                        <th scope="col">Business Name</th>
                        <th scope="col">Application Date</th>
                        <th>Licensing Officer</th>
                        <th>Status</th>
                        <th class="text-right" scope="col">Amount Paid</th>
                        <th></th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr :key="index" v-for="(item, index) in businesses" class="animated-row">
                        <td class="text-capitalize text-nowrap">{{item.billNo}}</td>
                        <td class="text-capitalize text-nowrap">{{item.businessID}}</td>
                        <td class="text-capitalize text-nowrap">
                          <a href="javascript: void(0);" class="text-primary fw-medium">{{item.businessName}}</a>
                        </td>
                        <td class="text-capitalize text-nowrap">{{formattedDate(item.dateCreated)}}</td>
                        <td>{{item.issuingOfficer || 'N/A'}}</td>
                        <td>
                          <span class="badge badge-soft-dark text-uppercase rounded-pill">{{item.stageStatus}}</span>
                        </td>
                        <td class="text-nowrap text-right">
                          <span class="fw-semibold">KES {{numberFormat(item.receiptAmount)}}</span>
                        </td>
                        <td>
                          <div class="d-flex justify-content-end">
                            <button @click="getBusinessDetails(item.businessID,item.billNo)" class="btn btn-primary btn-sm waves-effect waves-light text-nowrap me-3 btn-rounded" data-bs-target=".receipting-modal" data-bs-toggle="modal" type="button">
                              <i class="bx bx-show font-size-16 align-middle me-2"></i>
                              Application Details
                            </button>
                            <a @click="printBill(item.billNo)" class="btn btn-success btn-sm waves-effect waves-light btn-rounded" href="javascript: void(0);">
                              <i class="bx bx-printer font-size-16 align-middle me-2"></i>
                              Print Receipt
                            </a>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                      <tfoot class="table-dark">
                      <tr>
                        <th>{{businesses.length}} Certs</th>
                        <th class="text-nowrap" colspan="5"></th>
                        <td class="text-nowrap text-right">
                          <span class="fw-semibold">KES {{numberFormat(totalAmount)}}</span>
                        </td>
                        <td></td>
                      </tr>
                      </tfoot>
                    </table>

                    <div class="card-body px-5 d-flex flex-column justify-items-center align-items-center text-center" v-if="loading">
                      <div class="p-5 py-0 pt-3">
                        <div class="p-5">
                          <div class="spinner-border text-info m-1" role="status">
                            <span class="sr-only text-uppercase">Loading...</span>
                          </div>
                        </div>
                      </div>
                      <h4 class="text-uppercase">Loading Data</h4>
                      <p>We are fetching the data for you. Please wait...</p>
                    </div>

                    <div class="card-body d-flex flex-column justify-items-center align-items-center text-center" v-if="businesses.length<1 && loading === false">
                      <div class="p-5 py-0 pt-3">
                        <img :src="'./assets/images/no-results.png'" alt="No search results" class="img mb-4"/>
                      </div>
                      <h4>No Results To Show</h4>
                      <p>Sorry, we could not find any results that match your search or filter criteria.</p>
                    </div>
                  </div>
                </div>

                <div class="card-footer bg-white">
                  <nav aria-label="Page navigation" class="d-flex align-items-center justify-content-between">
                    <div class="d-flex align-items-center">
                      <span class="pr-3 pb-0 mb-0 font-13px">Rows Per Page</span>
                      <select class="form-select w-auto font-13px" v-model="pageSize">
                        <option value="10">10 Rows</option>
                        <option value="25">25 Rows</option>
                        <option value="50">50 Rows</option>
                        <option value="100">100 Rows</option>
                      </select>
                    </div>
                    <ul class="pagination">
                      <li :class="{ disabled: currentPage === 1 }" class="page-item">
                        <a @click="prevPage" class="page-link">Previous</a>
                      </li>
                      <li v-for="page in pagination(currentPage, totalPages, 3)" :key="page" :class="{ active: currentPage === page }" class="page-item">
                        <span v-if="page === '...'" class="page-link">{{ page }}</span>
                        <a v-else @click="goToPage(page)" class="page-link">{{ page }}</a>
                      </li>
                      <li :class="{ disabled: currentPage === totalPages }" class="page-item">
                        <a @click="nextPage" class="page-link">Next</a>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div aria-hidden="true" aria-labelledby="myLargeModalLabel" class="modal fade receipting-modal" role="dialog" tabindex="-1">
        <div class="modal-dialog modal-lg modal-dialog-centered modal-full modal-fullscreen">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Business Details</h5>
              <span class="badge rounded-pill bg-warning text-uppercase font-12px mx-3">{{entries.stageStatus}}</span>
              <button aria-label="Close" class="btn-close" data-bs-dismiss="modal" type="button"></button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-12">
                  <div class="hori-timeline mt-4">
                    <div class="owl-carousel owl-theme navs-carousel events timeline-carousel" id="timeline-carousel">
                      <div :class="item.completed==='active' ? 'active' : ''" class="item event-list" v-for="(item, index) in statuses" :key="index" style="display: inline-block; width: 350px">
                        <div>
                          <div class="event-date">
                            <div class="text-primary mb-1">{{getHumanDate(item.updatedDate)}}</div>
                            <h5 class="mb-4">{{item.status}}</h5>
                          </div>
                          <div class="event-down-icon">
                            <i v-if="item.completed==='true'" class="bx bxs-check-circle h1 text-success down-arrow-icon"></i>
                            <i v-if="item.completed==='false' || item.completed==='active'" class="bx bx-down-arrow-circle h1 text-primary down-arrow-icon"></i>
                          </div>
                          <div class="mt-3 px-3">
                            <p class="text-muted text-capitalize"><a href="javascript: void(0);">{{item.issuingOfficer}}</a></p>
                            <p v-if="item.statusID !== '2'" class="text-muted text-capitalize mb-1">
                              <i class="bx bx-map"></i>{{item.location}}
                            </p>
                            <p v-if="item.completed === 'true' && item.statusID==='2'" @click="printReceipt()" class="text-muted text-capitalize mb-1">
                              <a href="javascript: void(0);"><i class="bx bx-receipt"></i> View Receipt {{item.billNo}}</a>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-sm-12 col-md-4">
                  <div class="row">
                    <div class="col-12 mt-4">
                      <div class="bg-info border-2 bg-soft p-2 mb-4 d-flex align-items-center rounded">
                        <i class="bx bx-briefcase-alt-2 font-28 mr-15px"></i>
                        <p class="fw-semibold mb-0 pb-0">Business Details</p>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="table-responsive">
                        <table class="table table-nowrap vertical-align-middle table-striped table-sm">
                          <thead class="table-light">
                          <th class="text-right text-uppercase" colspan="3">
                            Verification Status<br>
                            <a href="user-details.html">({{entries.issuingOfficer}})</a>
                          </th>
                          </thead>
                          <tbody>
                          <tr>
                            <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Business Name</p></td>
                            <td>{{businessDetails.businessName}}</td>
                            <td class="text-right"><i class="bx bx-check text-success font-28"></i></td>
                          </tr>
                          <tr>
                            <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Plot Number</p></td>
                            <td>{{businessDetails.plotNumber}}</td>
                            <td class="text-right"><i class="bx bx-check text-success font-28"></i></td>
                          </tr>
                          <tr>
                            <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">KRA Pin No.</p></td>
                            <td>{{businessDetails.kraPin}}</td>
                            <td class="text-right"><i class="bx bx-check text-success font-28"></i></td>
                          </tr>
                          <tr>
                            <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">VAT No.</p></td>
                            <td>{{businessDetails.kraPin}}</td>
                            <td class="text-right"><i class="bx bx-check text-success font-28"></i></td>
                          </tr>
                          <tr>
                            <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Business Activity</p></td>
                            <td>{{businessDetails.businessDes}}</td>
                            <td class="text-right"><i class="bx bx-check text-success font-28"></i></td>
                          </tr>
                          <tr v-if="businessDetails.feeID === billDetail.feeID">
                            <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Business Sub category</p></td>
                            <td>{{billDetail.feeDescription}}</td>
                            <td class="text-right"><i class="bx bx-check text-success font-28"></i></td>
                          </tr>
                          <tr class="text-danger fw-semibold" v-if="businessDetails.feeID !== billDetail.feeID">
                            <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Business Sub category</p></td>
                            <td>{{billDetail.feeDescription}}</td>
                            <td class="text-right"><i class="bx bx-x text-danger font-28"></i></td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div class="col-12" v-if="businessDetails.feeID !== billDetail.feeID">
                      <div class="table-responsive">
                        <table class="table table-nowrap vertical-align-middle table-striped table-sm">
                          <thead class="table-light">
                          <th colspan="3">
                            Corrections Needed/Done<br>
                            <a href="user-details.html">({{entries.issuingOfficer}})</a>
                          </th>
                          </thead>
                          <tbody>
                          <tr class="fw-semibold text-capitalize">
                            <td class="text-primary">
                              <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Business Sub category</p>
                            </td>
                            <td>
                              <span class="text-primary">change to:</span>
                              {{businessDetails.businessSubCategory}}
                            </td>
                            <td class="text-right"><i class="bx bx-x text-danger font-28"></i></td>
                          </tr>
                          <tr class="fw-semibold text-capitalize">
                            <td class="text-primary">
                              <p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Additional Amount</p>
                            </td>
                            <td>
                              <span class="text-primary">
                                KES {{feesAndCharges.unitFeeAmount - billDetail.receiptAmount}}
                              </span>
                              (BILL NO. {{billDetail.billNo}})
                            </td>
                            <td class="text-right"><i class="bx bx-x text-danger font-28"></i></td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-sm-12 col-md-4">
                  <div class="row">
                    <div class="col-12 mt-4">
                      <div class="bg-warning border-2 bg-soft p-2 mb-4 d-flex align-items-center rounded">
                        <i class="bx bxs-user-pin font-28 mr-15px"></i>
                        <p class="fw-semibold mb-0 pb-0">Owner Details</p>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="table-responsive">
                        <table class="table table-nowrap vertical-align-middle table-striped table-sm">
                          <thead class="table-light">
                          <th class="text-right text-uppercase" colspan="3">
                            Verification Status<br>
                            <a href="user-details.html">({{businessDetails.createdBy}})</a>
                          </th>
                          </thead>
                          <tbody>
                          <tr>
                            <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Owner's Full Names</p></td>
                            <td>{{businessDetails.fullNames}}</td>
                            <td class="text-right"><i class="bx bx-check text-success font-28"></i></td>
                          </tr>
                          <tr>
                            <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">ID/PPT No.</p></td>
                            <td>{{businessDetails.ownerID}}</td>
                            <td class="text-right"><i class="bx bx-check text-success font-28"></i></td>
                          </tr>
                          <tr>
                            <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Owner's Email</p></td>
                            <td>{{businessDetails.ownerEmail}}</td>
                            <td class="text-right"><i class="bx bx-check text-success font-28"></i></td>
                          </tr>
                          <tr>
                            <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Owner's Mobile No.</p></td>
                            <td>
                              <a :href="'tel:' + businessDetails.ownerPhone">
                                {{maskPhoneNumber(businessDetails.ownerPhone)}}
                              </a>
                            </td>
                            <td class="text-right"><i class="bx bx-check text-success font-28"></i></td>
                          </tr>
                          <tr>
                            <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Alternative Mobile No.</p></td>
                            <td>
                              <a :href="'tel:' + businessDetails.ownerPhone">
                                {{maskPhoneNumber(businessDetails.ownerPhone)}}
                              </a>
                            </td>
                            <td class="text-right"><i class="bx bx-check text-success font-28"></i></td>
                          </tr>
                          <tr>
                            <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Postal Address</p></td>
                            <td>{{businessDetails.postalAddress}}</td>
                            <td class="text-right"><i class="bx bx-check text-success font-28"></i></td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-sm-12 col-md-4">
                  <div class="row">
                    <div class="col-12 mt-4">
                      <div class="bg-danger border-2 bg-soft p-2 mb-4 d-flex align-items-center rounded">
                        <i class="bx bx-phone-call font-28 mr-15px"></i>
                        <p class="fw-semibold mb-0 pb-0">Location and Contact Information</p>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="table-responsive">
                        <table class="table table-nowrap vertical-align-middle table-striped table-sm">
                          <thead class="table-light">
                          <th class="text-right text-uppercase" colspan="3">
                            Verification Status<br>
                            <a href="user-details.html">({{entries.issuingOfficer}})</a>
                          </th>
                          </thead>
                          <tbody>
                          <tr>
                            <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Business Mobile No.</p></td>
                            <td>
                              <a :href="'tel:' + businessDetails.businessPhone">
                                {{maskPhoneNumber(businessDetails.businessPhone)}}
                              </a>
                            </td>
                            <td class="text-right"><i class="bx bx-check text-success font-28"></i></td>
                          </tr>
                          <tr>
                            <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Alternative Phone No</p></td>
                            <td>
                              <a :href="'tel:' + businessDetails.businessPhone">
                                {{maskPhoneNumber(businessDetails.businessPhone)}}
                              </a>
                            </td>
                            <td class="text-right"><i class="bx bx-check text-success font-28"></i></td>
                          </tr>
                          <tr>
                            <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Business Email address</p></td>
                            <td>
                              <a :href="'mailto:' + businessDetails.businessEmail">
                                {{businessDetails.businessEmail}}
                              </a>
                            </td>
                            <td class="text-right"><i class="bx bx-check text-success font-28"></i></td>
                          </tr>
                          <tr>
                            <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Sub county</p></td>
                            <td>{{businessDetails.subCountyName}}</td>
                            <td class="text-right"><i class="bx bx-check text-success font-28"></i></td>
                          </tr>
                          <tr>
                            <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Ward</p></td>
                            <td>{{businessDetails.wardName}}</td>
                            <td class="text-right"><i class="bx bx-check text-success font-28"></i></td>
                          </tr>
                          <tr>
                            <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Physical address/Street</p></td>
                            <td>{{businessDetails.physicalAddress}}</td>
                            <td class="text-right"><i class="bx bx-check text-success font-28"></i></td>
                          </tr>
                          <tr>
                            <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Building Name</p></td>
                            <td>{{businessDetails.buildingName}}</td>
                            <td class="text-right"><i class="bx bx-check text-success font-28"></i></td>
                          </tr>
                          <tr>
                            <td><p class="the-bill-item mb-0 p-0 m-0 fw-semibold">Stall/Room No.</p></td>
                            <td>{{businessDetails.roomNo}}</td>
                            <td class="text-right"><i class="bx bx-check text-success font-28"></i></td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-sm-12 col-md-8">
                  <div class="row">
                    <div class="col-12 mt-4">
                      <div class="bg-dark border-2 bg-soft p-2 mb-4 d-flex align-items-center rounded">
                        <i class="bx bx-map font-28 mr-15px"></i>
                        <p class="fw-semibold mb-0 pb-0">Map View</p>
                      </div>
                    </div>
                    <div class="col-12">
                      <iframe frameborder="0" scrolling="no" style="width: 100%; height: 450px; border-radius: 8px;" :src="iframeSrc"></iframe>
                    </div>
                  </div>
                </div>

                <div class="col-sm-12 col-md-4">
                  <div class="row">
                    <div class="col-12 mt-4">
                      <div class="bg-danger border-2 bg-soft p-2 mb-4 d-flex align-items-center rounded">
                        <i class="bx bxs-edit-alt font-28 mr-15px"></i>
                        <p class="fw-semibold mb-0 pb-0">Revenue Officer Notes ({{entries.issuingOfficer}})</p>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="alert alert-warning border-1 border-warning" role="alert">
                        {{entries.comments || 'No comments available'}}
                      </div>
                    </div>
                  </div>

                  <div v-if="getRight('APPROVE SBP INSPECTION')" class="col-12">
                    <div class="card shadow-sm border-0">
                      <div class="card-body">
                        <div class="d-flex flex-column mb-3">
                          <label class="mb-1 fw-semibold">
                            Inspection Remarks <span class="text-danger">*</span>
                          </label>
                          <small class="text-muted">Enter detailed inspection remarks (required - minimum 10 characters)</small>
                        </div>
                        <textarea v-model="comments" cols="30" rows="5" class="form-control mb-3" :class="{ 'is-invalid': showRemarksError }" placeholder="Enter detailed inspection remarks here... (MANDATORY)" :disabled="isProcessing" required></textarea>
                        <div v-if="showRemarksError" class="invalid-feedback d-block mb-2">
                          <i class="bx bx-error-circle me-1"></i>
                          Inspection remarks are mandatory. Please provide detailed remarks (minimum 10 characters).
                        </div>
                        <div class="text-end mb-3">
                          <small :class="comments.trim().length < 10 ? 'text-danger' : 'text-muted'">
                            {{ comments.trim().length }} / 10 minimum characters
                            <span v-if="comments.trim().length < 10" class="text-danger fw-bold">
                              ({{ 10 - comments.trim().length }} more needed)
                            </span>
                          </small>
                        </div>
                        <div class="d-grid gap-2">
                          <button v-if="viewApproved" @click="initiateApproval" class="btn btn-success btn-lg" :disabled="isProcessing || !comments.trim() || comments.trim().length < 10" :title="!comments.trim() || comments.trim().length < 10 ? 'Please enter inspection remarks (minimum 10 characters)' : 'Click to approve'">
                            <span v-if="!isProcessing">
                              <i class="bx bx-check-circle me-2"></i>
                              Approve for Certification
                            </span>
                            <span v-else>
                              <span class="spinner-border spinner-border-sm me-2"></span>
                              Processing...
                            </span>
                          </button>
                          <button v-if="viewApproved" @click="initiateDecline" class="btn btn-danger btn-lg" :disabled="isProcessing || !comments.trim() || comments.trim().length < 10" :title="!comments.trim() || comments.trim().length < 10 ? 'Please enter inspection remarks (minimum 10 characters)' : 'Click to decline'">
                            <span v-if="!isProcessing">
                              <i class="bx bx-x-circle me-2"></i>
                              Decline Application
                            </span>
                            <span v-else>
                              <span class="spinner-border spinner-border-sm me-2"></span>
                              Processing...
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <a v-if="viewApproved" @click="printReceipt()" class="btn btn-primary waves-effect waves-light" type="button">
                <i class="mdi mdi-printer font-size-16 align-middle me-2"></i>
                Print Receipt
              </a>
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade" id="confirmationModal" tabindex="-1" aria-labelledby="confirmationModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header border-0">
              <h5 class="modal-title" id="confirmationModalLabel">{{ confirmationTitle }}</h5>
              <button type="button" class="btn-close" @click="cancelConfirmation" :disabled="isProcessing"></button>
            </div>
            <div class="modal-body text-center py-4">
              <div v-if="confirmationAction === 'approve'" class="mb-3">
                <i class="bx bx-check-circle text-success" style="font-size: 64px;"></i>
              </div>
              <div v-else-if="confirmationAction === 'decline'" class="mb-3">
                <i class="bx bx-x-circle text-danger" style="font-size: 64px;"></i>
              </div>
              <h5 class="mb-3">{{ confirmationMessage }}</h5>
              <div class="text-start bg-light rounded p-3 mb-3">
                <p class="mb-1"><strong>Business:</strong> {{ businessDetails.businessName }}</p>
                <p class="mb-1"><strong>Business ID:</strong> {{ businessDetails.businessID }}</p>
                <p class="mb-1"><strong>Bill No:</strong> {{ billNo }}</p>
              </div>
              <div class="text-start bg-light rounded p-3">
                <p class="mb-1"><strong>Your Remarks:</strong></p>
                <p class="mb-0 text-muted">{{ comments }}</p>
              </div>
            </div>
            <div class="modal-footer border-0">
              <button type="button" class="btn btn-secondary" @click="cancelConfirmation" :disabled="isProcessing">Cancel</button>
              <button type="button" :class="confirmationAction === 'approve' ? 'btn btn-success' : 'btn btn-danger'" @click="proceedWithAction" :disabled="isProcessing">
                <span v-if="!isProcessing">
                  {{ confirmationAction === 'approve' ? 'Confirm Approval' : 'Confirm Decline' }}
                </span>
                <span v-else>
                  <span class="spinner-border spinner-border-sm me-2"></span>
                  Processing...
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade" id="feedbackModal" tabindex="-1" aria-labelledby="feedbackModalLabel" aria-hidden="true" data-bs-backdrop="static">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-body text-center py-5">
              <div v-if="feedbackType === 'success'" class="mb-3">
                <i class="bx bx-check-circle text-success animate-success" style="font-size: 72px;"></i>
              </div>
              <div v-else-if="feedbackType === 'error'" class="mb-3">
                <i class="bx bx-x-circle text-danger animate-error" style="font-size: 72px;"></i>
              </div>
              <h4 class="mb-3">{{ feedbackTitle }}</h4>
              <p class="text-muted">{{ feedbackMessage }}</p>
              <button type="button" class="btn btn-primary mt-3" @click="closeFeedback">OK</button>
            </div>
          </div>
        </div>
      </div>

      <FixSameBusinessID ref="fixBusinessID" :business-i-d="currentBusinessID" :bill-no="currentBillNo" @success="handleFixSuccess" @reload="getApplicationsPaginated('')"/>

      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6"></div>
            <div class="col-sm-6">
              <div class="text-sm-end d-sm-block">County Government</div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>
  <div class="rightbar-overlay"></div>
  </body>
</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation";
import ToolBar from "@/components/sbp/ToolBar";
import FixSameBusinessID from '@/components/sbp/FixSameBusinessID.vue';
import router from "@/router";
import { authUrl, biller, execute, executeDownload, getRight, trade } from "@/api";
import moment from 'moment';

export default {
  name: "PendingInspection",
  components: { ToolBar, NavigationBar, FixSameBusinessID },

  data() {
    return {
      loading: false,
      viewApproved: false,
      isProcessing: false,
      isDownloading: false,
      currentPage: 1,
      totalPages: 0,
      pageSize: 10,
      totalItems: 0,
      search: '',
      dateFrom: '',
      dateTo: '',
      businesses: [],
      businessDetails: {},
      billDetail: {},
      feesAndCharges: {},
      receiptDetails: {},
      receiptInfos: [],
      statuses: [],
      totalAmount: 0,
      pendingCount: 0,
      todayCount: 0,
      comments: '',
      billNo: '',
      showRemarksError: false,
      currentBusinessID: '',
      currentBillNo: '',
      subCounties: [],
      wards: [],
      entries: {
        statusID: null,
        stageStatus: null,
        issuingOfficer: null,
        comments: null
      },
      confirmationAction: '',
      confirmationTitle: '',
      confirmationMessage: '',
      feedbackType: '',
      feedbackTitle: '',
      feedbackMessage: ''
    };
  },

  computed: {
    iframeSrc() {
      return 'https://maps.google.com/maps?q=' + this.businessDetails.lat + ',' + this.businessDetails.lng + '&t=&z=13&ie=UTF8&iwloc=&output=embed';
    }
  },

  mounted() {
    this.dateFrom = '';
    this.dateTo = '';
    this.getApplicationsPaginated("");
    this.getSubCounties();
    this.calculateStatistics();
  },

  watch: {
    pageSize() {
      this.currentPage = 1;
      this.getApplicationsPaginated("");
    },
    search() {
      this.getApplicationsPaginated(this.search);
    },
    dateFrom() {
      if (this.dateFrom && this.dateTo) {
        this.getApplicationsPaginated("");
      }
    },
    dateTo() {
      if (this.dateFrom && this.dateTo) {
        this.getApplicationsPaginated("");
      }
    },
    comments() {
      if (this.comments && this.comments.trim() && this.comments.trim().length >= 10) {
        this.showRemarksError = false;
      }
    }
  },

  methods: {
    async getApplicationsPaginated(keyword) {
      this.loading = true;
      this.businesses = [];
      try {
        const data = new FormData();
        data.append("function", "getApplicationsPaginated");
        data.append("statusID", "3");
        data.append("search", keyword || "");
        data.append("dateFrom", this.dateFrom);
        data.append("dateTo", this.dateTo);
        data.append("page", this.currentPage);
        data.append("rows_per_page", this.pageSize);

        const res = await execute(data, trade);
        if (res.data.success) {
          this.businesses = res.data.data.businesses;
          this.totalItems = parseInt(res.data.data.totalItems.count);
          this.totalPages = Math.ceil(this.totalItems / this.pageSize);
          this.totalAmount = this.businesses.reduce((sum, item) => sum + parseFloat(item.receiptAmount || 0), 0);
          this.calculateStatistics();
        }
      } catch (error) {
        console.error("Error loading applications:", error);
        this.showFeedback('error', 'Error', 'Failed to load applications. Please try again.');
      } finally {
        this.loading = false;
      }
    },

    calculateStatistics() {
      const today = moment().format('YYYY-MM-DD');
      this.pendingCount = this.businesses.filter(b => b.stageStatus === 'Pending' || b.stageStatus === 'Approved').length;
      this.todayCount = this.businesses.filter(b => moment(b.dateCreated).format('YYYY-MM-DD') === today).length;
    },

    async getBusinessDetails(businessID, billNo) {
      this.viewApproved = false;
      this.billNo = billNo;
      this.statuses = [];
      this.comments = '';
      this.showRemarksError = false;
      try {
        const data = new FormData();
        data.append("function", "getBusinessDetails");
        data.append("billNo", billNo);
        data.append("sessionNames", sessionStorage.getItem("sessionNames"));
        data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
        const res = await execute(data, trade);
        if (res.data.success) {
          this.viewApproved = res.data.data.entries?.statusID === '3';
          this.statuses = res.data.data.statuses;
          this.businessDetails = res.data.data.business;
          this.billDetail = res.data.data.bill?.billDetails || {};
          this.feesAndCharges = res.data.data.feesAndCharge || {};
          this.receiptDetails = res.data.data.receipt?.receiptDetails || {};
          this.receiptInfos = res.data.data.receipt?.receiptInfos || [];
          this.entries = res.data.data.entries || {};
          this.$nextTick(() => this.timelineCarousel());
        }
      } catch (error) {
        console.error("Error loading business details:", error);
        this.showFeedback('error', 'Error', 'Failed to load business details. Please try again.');
      }
    },

    timelineCarousel() {
      if (window.$ && window.$.fn.owlCarousel) {
        $("#timeline-carousel").owlCarousel({
          items: 1,
          loop: false,
          margin: 0,
          nav: true,
          navText: ["<i class='mdi mdi-chevron-left'></i>", "<i class='mdi mdi-chevron-right'></i>"],
          dots: false,
          responsive: { 576: { items: 2 }, 768: { items: 4 } }
        });
      }
    },

    initiateApproval() {
      // CRITICAL FIX: Do NOT set isProcessing here - only validate
      if (this.isProcessing) {
        console.log('Already processing, ignoring duplicate click');
        return;
      }

      if (!this.comments || !this.comments.trim()) {
        this.showRemarksError = true;
        this.showFeedback('error', 'Remarks Required', 'Inspection remarks are mandatory. Please enter your inspection remarks before approving.');
        return;
      }

      if (this.comments.trim().length < 10) {
        this.showRemarksError = true;
        this.showFeedback('error', 'Insufficient Remarks', 'Please provide more detailed inspection remarks (minimum 10 characters).');
        return;
      }

      // Set confirmation data but do NOT set isProcessing yet
      this.confirmationAction = 'approve';
      this.confirmationTitle = 'Confirm Approval';
      this.confirmationMessage = 'Are you sure you want to approve this application for certification?';

      const mainModal = bootstrap.Modal.getInstance(document.querySelector('.receipting-modal'));
      if (mainModal) mainModal.hide();

      setTimeout(() => {
        const confirmModal = new bootstrap.Modal(document.getElementById('confirmationModal'));
        confirmModal.show();
      }, 300);
    },

    initiateDecline() {
      // CRITICAL FIX: Do NOT set isProcessing here - only validate
      if (this.isProcessing) {
        console.log('Already processing, ignoring duplicate click');
        return;
      }

      if (!this.comments || !this.comments.trim()) {
        this.showRemarksError = true;
        this.showFeedback('error', 'Remarks Required', 'Inspection remarks are mandatory. Please enter your inspection remarks before declining.');
        return;
      }

      if (this.comments.trim().length < 10) {
        this.showRemarksError = true;
        this.showFeedback('error', 'Insufficient Remarks', 'Please provide more detailed inspection remarks (minimum 10 characters).');
        return;
      }

      // Set confirmation data but do NOT set isProcessing yet
      this.confirmationAction = 'decline';
      this.confirmationTitle = 'Confirm Decline';
      this.confirmationMessage = 'Are you sure you want to decline this application?';

      const mainModal = bootstrap.Modal.getInstance(document.querySelector('.receipting-modal'));
      if (mainModal) mainModal.hide();

      setTimeout(() => {
        const confirmModal = new bootstrap.Modal(document.getElementById('confirmationModal'));
        confirmModal.show();
      }, 300);
    },

    cancelConfirmation() {
      // Reset processing flag when canceling
      this.isProcessing = false;
      const confirmModal = bootstrap.Modal.getInstance(document.getElementById('confirmationModal'));
      if (confirmModal) confirmModal.hide();
      setTimeout(() => {
        const mainModal = new bootstrap.Modal(document.querySelector('.receipting-modal'));
        mainModal.show();
      }, 300);
    },

    async proceedWithAction() {
      // CRITICAL: Set isProcessing here ONLY when user actually clicks confirm
      if (this.isProcessing) {
        console.log('Already processing action, ignoring duplicate');
        return;
      }

      if (!this.comments || !this.comments.trim() || this.comments.trim().length < 10) {
        const confirmModal = bootstrap.Modal.getInstance(document.getElementById('confirmationModal'));
        if (confirmModal) confirmModal.hide();
        this.showFeedback('error', 'Remarks Required', 'Inspection remarks are mandatory. Please provide detailed remarks (minimum 10 characters) before proceeding.');
        setTimeout(() => {
          const mainModal = new bootstrap.Modal(document.querySelector('.receipting-modal'));
          mainModal.show();
          this.showRemarksError = true;
        }, 300);
        return;
      }

      // NOW set isProcessing to true
      this.isProcessing = true;

      if (this.confirmationAction === 'approve') {
        await this.businessValidation("Approved");
      } else if (this.confirmationAction === 'decline') {
        await this.businessValidation("Declined");
      }
    },

    async businessValidation(stageStatus) {
      if (!this.comments || !this.comments.trim() || this.comments.trim().length < 10) {
        this.showFeedback('error', 'Validation Error', 'Inspection remarks are mandatory and must be at least 10 characters. Operation cancelled.');
        this.isProcessing = false;
        return;
      }

      try {
        const data = new FormData();
        data.append("function", "businessValidation");
        data.append("business", JSON.stringify(this.businessDetails));
        data.append("description", "No Changes done");
        data.append("comments", this.comments.trim());
        data.append("billNo", this.billNo);
        data.append("idNo", sessionStorage.getItem("idNo"));
        data.append("names", sessionStorage.getItem("names"));
        data.append("phoneNumber", sessionStorage.getItem("phoneNumber"));
        data.append("sessionNames", sessionStorage.getItem("sessionNames"));
        data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
        data.append("sessionPhoneNumber", sessionStorage.getItem("sessionPhoneNumber"));
        data.append("balanceAmount", this.billDetail.billBalance);
        data.append("stageStatus", stageStatus);

        const res = await execute(data, trade);
        const confirmModal = bootstrap.Modal.getInstance(document.getElementById('confirmationModal'));
        if (confirmModal) confirmModal.hide();

        if (res.data.success) {
          this.showFeedback('success', `Application ${stageStatus}!`, `The application has been successfully ${stageStatus.toLowerCase()}.`);
          this.comments = '';
          this.showRemarksError = false;
          await this.getApplicationsPaginated("");
        } else {
          this.showFeedback('error', 'Operation Failed', res.data.message || "Failed to process the application. Please try again.");
        }
      } catch (error) {
        console.error("Error processing application:", error);
        const confirmModal = bootstrap.Modal.getInstance(document.getElementById('confirmationModal'));
        if (confirmModal) confirmModal.hide();
        this.showFeedback('error', 'Error', 'An error occurred while processing the application. Please try again.');
      } finally {
        this.isProcessing = false;
      }
    },

    showFeedback(type, title, message) {
      this.feedbackType = type;
      this.feedbackTitle = title;
      this.feedbackMessage = message;
      const feedbackModal = new bootstrap.Modal(document.getElementById('feedbackModal'));
      feedbackModal.show();
    },

    closeFeedback() {
      const feedbackModal = bootstrap.Modal.getInstance(document.getElementById('feedbackModal'));
      if (feedbackModal) feedbackModal.hide();
    },

    async downloadApplicationsPaginated() {
      this.isDownloading = true;
      try {
        const data = new FormData();
        data.append("function", "downloadApplicationsPaginated");
        data.append("statusID", "3");
        data.append("dateFrom", this.dateFrom);
        data.append("dateTo", this.dateTo);
        data.append("page", this.currentPage);
        data.append("rows_per_page", this.pageSize);

        const response = await executeDownload(data, trade);
        const link = document.createElement('a');
        link.href = URL.createObjectURL(response.data);
        link.download = `Inspection_Applications_${this.dateFrom || 'All'}_to_${this.dateTo || 'All'}.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.showFeedback('success', 'Download Complete', 'Report has been downloaded successfully.');
      } catch (error) {
        console.error("Download failed:", error);
        this.showFeedback('error', 'Download Failed', 'Failed to download the report. Please try again.');
      } finally {
        this.isDownloading = false;
      }
    },

    getSubCounties() {
      const data = new FormData();
      data.append("function", "getSubCounties");
      execute(data, authUrl).then(res => {
        if (res.data.success) this.subCounties = res.data.data.subCounties;
      }).catch(error => console.error("Error loading sub-counties:", error));
    },

    getWards(subCountyID) {
      const data = new FormData();
      data.append("function", "getWards");
      data.append("subCountyID", subCountyID);
      execute(data, authUrl).then(res => {
        if (res.data.success) this.wards = res.data.data.wards;
      }).catch(error => console.error("Error loading wards:", error));
    },

    selectedSubCounty(event) {
      if (event.target.value) {
        const data = JSON.parse(event.target.value);
        this.getWards(data.subCountyID);
        this.getApplicationsPaginated(data.subCountyName);
      }
    },

    selectedWard(event) {
      if (event.target.value) {
        const data = JSON.parse(event.target.value);
        this.getApplicationsPaginated(data.wardName);
      }
    },

    getHumanDate(dateData) {
      if (dateData === "-") return "-";
      const dateObject = new Date(Date.parse(dateData));
      return dateObject.toDateString();
    },

    maskPhoneNumber(phone) {
      if (!phone || typeof phone !== 'string') return phone;
      const digits = phone.replace(/\D/g, '');
      if (digits.length > 4) {
        return phone.slice(0, 2) + phone.slice(2, -2).replace(/\d/g, '*') + phone.slice(-2);
      }
      return phone;
    },

    numberFormat(num) {
      return new Intl.NumberFormat("en-GB").format(num);
    },

    formattedDate(date) {
      return moment(date).format('DD MMM YYYY hh:mm A') + ' (' + moment(date).fromNow() + ')';
    },

    printBill(billNo) {
      localStorage['params'] = JSON.stringify({ billNo: billNo });
      const routeData = this.$router.resolve({ name: 'bill' });
      window.open(routeData.href, '_blank');
    },

    printReceipt() {
      if (!this.receiptDetails.receiptNo) {
        this.showFeedback('error', 'No Receipt', 'Receipt is not available for this application.');
        return;
      }
      localStorage['params'] = JSON.stringify({ receiptNo: this.receiptDetails.receiptNo });
      const routeData = this.$router.resolve({ name: 'receipt' });
      window.open(routeData.href, '_blank');
    },

    getRight(type) {
      return getRight(type);
    },

    handleFixSuccess(result) {
      this.getApplicationsPaginated("");
    },

    pagination(current, total, maxVisible) {
      let pages = [];
      let start = current - Math.floor(maxVisible / 2);
      let end = current + Math.floor(maxVisible / 2);
      if (start < 1) {
        start = 1;
        end = start + maxVisible - 1;
        if (end > total) end = total;
      }
      if (end > total) {
        end = total;
        start = end - maxVisible + 1;
        if (start < 1) start = 1;
      }
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      if (start > 1) pages.unshift("...");
      if (end < total) pages.push("...");
      return pages;
    },

    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.getApplicationsPaginated("");
      }
    },

    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.getApplicationsPaginated("");
      }
    },

    goToPage(page) {
      if (page !== '...' && page !== this.currentPage) {
        this.currentPage = page;
        this.getApplicationsPaginated("");
      }
    }
  }
};
</script>

<style scoped>
.spinner-border-sm { width: 1rem; height: 1rem; border-width: 0.2em; }
.btn:disabled { opacity: 0.65; cursor: not-allowed; }
.btn-rounded { border-radius: 20px; }
.mini-stats-wid .mini-stat-icon { width: 60px; height: 60px; }
.card { box-shadow: 0 0.125rem 0.25rem rgba(0,0,0,0.075); transition: all 0.3s ease-in-out; border: none; }
.card:hover { box-shadow: 0 0.5rem 1rem rgba(0,0,0,0.15); }
.hover-card:hover { transform: translateY(-3px); box-shadow: 0 0.75rem 1.5rem rgba(18,38,63,.1); }
.shadow-sm { box-shadow: 0 0.125rem 0.25rem rgba(0,0,0,0.075)!important; }
.counter { font-weight: 600; font-size: 1.5rem; }
.animated-row { animation: fadeIn 0.3s ease-in; }
@keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
@keyframes successPulse { 0% { transform: scale(0.9); opacity: 0; } 50% { transform: scale(1.1); } 100% { transform: scale(1); opacity: 1; } }
@keyframes errorShake { 0%, 100% { transform: translateX(0); } 25% { transform: translateX(-10px); } 75% { transform: translateX(10px); } }
.animate-success { animation: successPulse 0.5s ease; }
.animate-error { animation: errorShake 0.5s ease; }
.bg-gradient { background-image: linear-gradient(135deg, rgba(255,255,255,0.1) 0%, transparent 100%); }
.rounded { border-radius: 8px!important; }
.is-invalid { border-color: #dc3545!important; }
.invalid-feedback { color: #dc3545; font-size: 0.875rem; margin-top: 0.25rem; }
.modal-content { border: none; border-radius: 12px; }
.modal-header, .modal-footer { border: none; }
.modal-body { padding: 2rem; }
.table-striped tbody tr:nth-of-type(odd) { background-color: rgba(0,0,0,.02); }
.table-hover tbody tr:hover { background-color: rgba(0,0,0,.04); }
.badge { font-weight: 500; padding: 0.5rem 1rem; }
.rounded-pill { border-radius: 50rem!important; }
@media (max-width: 768px) { .modal-fullscreen { max-width: 100%; } .counter { font-size: 1.25rem; } }
</style>